import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  // Nếu modal không mở, không render gì cả
  if (!isOpen) {
    return null;
  }

  return (
    // Lớp phủ mờ toàn màn hình, nhấn vào sẽ đóng modal
    <div className="modal-overlay" onClick={onClose}>
      {/* Nội dung modal, chặn sự kiện click để không bị đóng khi nhấn vào trong */}
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button onClick={onClose} className="modal-close-btn">&times;</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;